import { Routes } from "@angular/router";
import { BranchesListComponent } from "./branches-list/branches-list.component";
import { BranchesEditComponent } from "./branches-edit/branches-edit.component";
import { BranchesDeleteComponent } from "./branches-delete/branches-delete.component";
import { BranchDetailsComponent } from "./branch-details/branch-details.component";
import { BranchCreateComponent } from "./branch-create/branch-create.component";
import { actionsGuard } from "../shared/guards/actions.guard";

export const branchesRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },
  { path: 'list', component: BranchesListComponent, canActivate: [actionsGuard] },
  { path: 'create', component: BranchCreateComponent, canActivate: [actionsGuard] },
  { path: 'edit/:id', component: BranchesEditComponent, canActivate: [actionsGuard] },
  { path: 'delete/:id', component: BranchesDeleteComponent, canActivate: [actionsGuard] },
  { path: 'details/:id', component: BranchDetailsComponent, canActivate: [actionsGuard] },
]
